export default __webpack_public_path__ + "static/img-abouteambanner-1afad646c11c87a774d63b1f52eecf05.jpg";